export var FundFullDeploymentTrigger;
(function (FundFullDeploymentTrigger) {
    FundFullDeploymentTrigger["Allocation"] = "ALLOCATION";
    FundFullDeploymentTrigger["AllocationPreview"] = "ALLOCATION_PREVIEW";
    FundFullDeploymentTrigger["FundSettings"] = "FUND_SETTINGS";
})(FundFullDeploymentTrigger || (FundFullDeploymentTrigger = {}));
//# sourceMappingURL=index.js.map